module.exports = __webpack_public_path__ + "static/img/logoing.11a069a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoing.jpg
// module id = 7iKZ
// module chunks = 0